var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBadge({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40.477,
    height: 50,
    viewBox: "0 0 40.477 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1.184,
    y1: 0.681,
    x2: -0.086,
    y2: 0.868,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fa8800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e31926"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.5,
    y1: 0,
    x2: 0.5,
    y2: 1,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fa8800"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "badge",
    transform: "translate(-7 -3.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_575",
    "data-name": "Path 575",
    d: "M37.391,27H14V48.967l11.7-3.661,11.7,3.661Z",
    transform: "translate(1.543 4.034)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_576",
    "data-name": "Path 576",
    d: "M37.391,31.332l-.581.013a6.14,6.14,0,0,0-5.185,3.125l-.329.567a1.492,1.492,0,0,1-2.047.575l-.559-.322a5.955,5.955,0,0,0-5.992,0l-.553.319a1.5,1.5,0,0,1-2.05-.574l-.329-.567a6.136,6.136,0,0,0-5.184-3.124L14,31.332v4.883l.485.011a1.513,1.513,0,0,1,1.28.771l.33.567a6.056,6.056,0,0,0,8.31,2.321l.556-.32a1.469,1.469,0,0,1,1.474,0l.56.322a6.005,6.005,0,0,0,3,.808,6.144,6.144,0,0,0,5.31-3.133L35.629,37a1.515,1.515,0,0,1,1.282-.771l.481-.011Z",
    transform: "translate(1.543 4.988)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_577",
    "data-name": "Path 577",
    d: "M46.673,25.008a3.894,3.894,0,0,1,0-3.776l.312-.563a3.9,3.9,0,0,0-1.413-5.24l-.554-.334a3.917,3.917,0,0,1-1.9-3.27L43.1,11.18a3.927,3.927,0,0,0-3.858-3.836L38.6,7.33a3.941,3.941,0,0,1-3.289-1.889l-.336-.55a3.955,3.955,0,0,0-5.272-1.4l-.567.31a3.958,3.958,0,0,1-3.8,0l-.565-.309a3.954,3.954,0,0,0-5.27,1.4l-.336.55a3.949,3.949,0,0,1-3.289,1.889l-.648.014a3.927,3.927,0,0,0-3.858,3.836l-.014.644a3.909,3.909,0,0,1-1.9,3.27l-.554.334a3.907,3.907,0,0,0-1.413,5.24l.312.563a3.894,3.894,0,0,1,0,3.776l-.311.562A3.9,3.9,0,0,0,8.9,30.811l.554.334a3.917,3.917,0,0,1,1.9,3.27l.014.644a3.927,3.927,0,0,0,3.858,3.836l.648.014A3.941,3.941,0,0,1,19.166,40.8l.336.55a3.956,3.956,0,0,0,5.272,1.4l.567-.31a3.958,3.958,0,0,1,3.8,0l.567.31a3.954,3.954,0,0,0,5.272-1.4l.336-.55A3.949,3.949,0,0,1,38.6,38.909l.648-.014a3.927,3.927,0,0,0,3.858-3.836l.014-.644a3.909,3.909,0,0,1,1.9-3.27l.554-.334a3.907,3.907,0,0,0,1.413-5.24Z",
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_578",
    "data-name": "Path 578",
    d: "M25.932,8.923a13.272,13.272,0,0,0-13.01,13.518A13.272,13.272,0,0,0,25.932,35.96a13.272,13.272,0,0,0,13.01-13.518A13.272,13.272,0,0,0,25.932,8.923Z",
    transform: "translate(1.305 1.305)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_579",
    "data-name": "Path 579",
    d: "M26.137,37.291A14.413,14.413,0,0,1,12,22.646,14.414,14.414,0,0,1,26.137,8,14.413,14.413,0,0,1,40.273,22.645,14.415,14.415,0,0,1,26.137,37.291Zm0-26.85a12.011,12.011,0,0,0-11.78,12.2,12.011,12.011,0,0,0,11.78,12.2,12.011,12.011,0,0,0,11.78-12.2A12.011,12.011,0,0,0,26.137,10.441Z",
    transform: "translate(1.102 1.102)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadge);
export default __webpack_public_path__ + "static/media/badge.b103002013cf06b04352f6be77ef5c18.svg";
export { ForwardRef as ReactComponent };